import { User } from "@/declare/interface/user";
import { StdResponse, coreAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";
import qs from "qs";

/**
 * 验证用户是否登录（通过请求头中的信息进行登陆验证）
 * @returns Promise 解析为 StdResponse，包含用户登录状态
 */
export function userCheckLogin(params?: {}): Promise<StdResponse<any>> {
    return coreAxios.get(`/users/check-login`, {
        params: params
    })
}
/**
 * 用户登录
 * @param user 用户信息
 * - username: 用户名
 * - password: 用户密码
 * @returns Promise 解析为 StdResponse，包含用户详细信息
 */
export function userLogin(user: User, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.post(`/users/login`, user, {
        params: params
    })
}

export function userMobileCodeLogin(mobile: string, authCode: string, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.post(`/users/mobile-login`, null, {
        params: {
            ...params,
            mobile: mobile,
            authCode: authCode,
        }
    })
}

/**
 * 根据用户ID获取用户信息
 * @param userId 用户ID
 * @returns Promise 解析为 AxiosResponse，包含用户信息
 */
export function getUser(userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users/${userId}`, {
        params: params
    })
}

/**
 * 获取用户信息列表
 * @returns Promise 解析为 AxiosResponse，包含用户信息
 */
export function getUsers(params?: {}, userStatusList?: number[]): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/users/multi-get`, userStatusList, {
        params: {
            ...params,
        }
    })
}

/**
 * 批量发送面试过程短信
 * @param userIds 
 * @param params 
 * @returns 
 */
export function sendUserMsgMulti(userIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/users/send-msg-multi`, userIds, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据用户Uuid修改用户信息
 * @param userId 用户Uuid
 * @param user 用户信息（名称、用户名、密码、类型、电话、邮箱、冻结状态、组织、职位、工作状态）
 * @returns Promise 解析为 AxiosResponse，包含用户信息
 */
export function changeUser(userId: number, user: User, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/users/${userId}`, user, {
        params: {
            params,
        }
    })
}

/**
 * 批量更新用户的用户状态
 * @param userIds 用户ids
 * @param newStatus 目标状态
 * @returns
 */
export function updateUserStatus(userIds: number[], newStatus: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/users/update-userStatus-list`, userIds, {
        params: {
            newStatus: newStatus
        }
    })
}

/**
 * 添加用户
 * 
 * @param user 用户信息
 *             - username: 用户名
 *             - password: 密码
 *             - type: 用户类型
 * @return 用户ID
 */
export function addUser(user: User, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/users`, user, {
        params: {
            params,
        }
    })
}

/**
 * 更新用户职位
 * @param userId 
 * @param positionCodeList 
 * @param params 
 * @returns 
 */
export function updateUserPosition(userId: number, positionCodeList: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/users/${userId}/positions`, positionCodeList, {
        params: {
            params,
        }
    })
}

/**
 * 发送验证码
 * @param mobile 
 * @returns 
 */
export function sendCodeSmsMsg(mobile: string): Promise<StdResponse<any>> {
    return coreAxios.post(`/users/code`, null, {
        params: {
            mobile: mobile,
        }
    })
}

/**
 * 提交忘记密码
 * @param data 
 * @param params 
 * @returns 
 */
export function forgetUserPasswordSubmit(data: any, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.post(`/users/password/forget`, data, {
        params: params
    })
}

/**
 * 更新员工在职状态
 * @param userId 
 * @param status 
 * @returns 
 */
export function updateUserWorkStatus(userId: number, status: number): Promise<StdResponse<any>> {
    return coreAxios.put(`/users/${userId}/status`, {}, {
        params: {
            status: status
        }
    })
}

/**
 * 获取离职的回调
 * @param userId 
 * @param status 
 * @returns 
 */
export function getLeaveCallback(userId: number): Promise<StdResponse<string>> {
    return coreAxios.post(`/user/leave-callback`, {}, {
        params: {
            userId: userId
        }
    })
}

/**
 * 根据机构id获得人员及人员参与的项目列表
 * @param institutionId 
 * @param params 
 * @returns 
 */
export function getUserAndProjectsByInstitutionId(institutionId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/institutions/${institutionId}/users`, {
        params: {
            params,
        }
    })
}

/**
 * 批量删除用户
 * @param userIds
 * @param params
 * @returns
 */
export function deleteUsers(userIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/users/delete`, userIds, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}


// ==================================以下二维码api=============================
/**
 * 根据页面uuid获取登录二维码图片base64
 * @param pageUuid 
 * @param params 
 * @returns 
 */
export function getPageQrcodeByPageUuid(pageUuid: string, codeWidth?: number, codeHeight?: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users/login/page`, {
        params: {
            pageUuid: pageUuid,
            codeWidth: codeWidth,
            codeHeight: codeHeight
        }
    })
}

/**
 * 获取验证码
 * @param mobile 
 * @returns 
 */
export function sendCode(mobile: string): Promise<StdResponse<any>> {
    return coreAxios.post(`/users/code`, {}, {
        params: {
            mobile: mobile
        }
    })
}

/**
 * 网页轮询页面二维码登录是否已经成功
 * @param pageUuid 
 * @returns 
 */
export function webGetQrcodeLoginUser(pageUuid: string): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users/login/pages/${pageUuid}`, {
        params: {
        }
    })
}

/**
 * 根据项目ID获取关联的用户列表
 * @param projectId 项目ID
 * @returns Promise 解析为 AxiosResponse，包含项目关联的用户信息
 */
export function getUsersByProjectId(projectId: number): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users/project/${projectId}`);
}
/**
 * 查询有收款记录的用户列表
 * @returns 
 */
export function getUsersByRevenue(): Promise<AxiosResponse<[]>> {
    return coreAxios.get(`/users/revenue`);
}

/**
 * 根据职位编码获取用户列表
 *
 * @param positionCode
 * @return
 */
export function getUserByPosition(positionCode: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users/positions/${positionCode}`, {
        params: params
    })
}

/**
 * 获取董事会成员+部门经理
 *
 * @return
 */
export function getUserByLeader(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users/company-leadership`, {
        params: params
    })
}

/**
 * 进行面试阶段人员计数
 *
 * @return
 */
export function statisticsUserStatus(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/statistics/user-status`, {
        params: params
    })
}